import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class DocumentConfigService {
  // 文档关联配置列表
  static async getDocumentParseTask(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DocumentParseTask?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 文档关联配置列表
  static async getDocumentTypeClass(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/document-type-class?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增文档关联配置
  static async addDocumentParseTask(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/DocumentParseTask', payload))
    return Callback(err, res)
  }
  // 获取配置详情
  static async getDocumentParseTaskById(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/DocumentParseTask/${payload.id}`))
    return Callback(err, res)
  }
  // 编辑配置
  static async updateDocumentParseTask(id, payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/DocumentParseTask/${id}`, payload)
    )
    return Callback(err, res)
  }
  // 批量删除配置
  static async deleteDocumentParseTask(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/DocumentParseTask/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 手动执行
  static async manualExecute(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DocumentParseTask/manual-execute/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 文档解析进度列表
  static async getDocumentRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DocumentParseTask/run-records?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // OCR配置列表
  static async getOcrDataReplaceList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/OcrDataReplace?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增OCR配置
  static async addOcrDataReplace(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/OcrDataReplace', payload))
    return Callback(err, res)
  }
  // 编辑OCR配置
  static async updateOcrDataReplace(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/OcrDataReplace/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 获取OCR配置详情
  static async getOcrDataReplaceById(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/OcrDataReplace/${payload.id}`))
    return Callback(err, res)
  }
  // 批量删除OCR配置
  static async deleteOcrDataReplace(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/OcrDataReplace/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 更新OCR配置
  static async ocrManualExecute() {
    const [err, res] = await To(wizStandardInstance.get('/api/std/OcrDataReplace/manual-execute'))
    return Callback(err, res)
  }
  // 解析实体下拉列表
  static async getTagTypeClass(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/tag-type-class?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
